import React, { useMemo } from 'react';

import { Control } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { colors } from 'constants-colors';
import { useSwireApp } from 'react-hooks';

import { WhiteLabelType } from 'application-types';

import { HookFormCheckBox } from '../../../../components/HookFormCheckBox';
import { SwireCommonTnC } from '../SwireCommonTnC';

type ReducedWhiteLabel = Pick<
  WhiteLabelType,
  'termsAndConditionsUrls' | 'privacyPolicyUrls' | 'name' | 'url'
>;

type Props = {
  control: Control<any>;
  whitelabel: ReducedWhiteLabel;
};

const labelStyles = {
  fontSize: '14px',
  fontWeight: 400,
  marginLeft: '10px',
};

export function SwireOtherTnC({ control, whitelabel }: Props) {
  const { t } = useTranslation();
  const { privacyPolicyUrl } = useSwireApp(whitelabel);

  const agreementLinks = useMemo(() => {
    const links: JSX.Element[] = [];

    links.push(createLink());

    return links;
  }, [whitelabel]);

  function createLink() {
    const linkText = t('web.onboarding.userProfile.privacyPolicyLabel');
    const redirectUrl = privacyPolicyUrl || '';

    return (
      <Link
        key={redirectUrl}
        data-test="link-to-parent"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'underline', color: 'inherit' }}
        to={{ pathname: redirectUrl }}
      >
        {linkText}
      </Link>
    );
  }

  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <SwireCommonTnC control={control} whitelabel={whitelabel} />
      </div>
      <div style={{ marginBottom: '20px' }}>
        <HookFormCheckBox
          control={control}
          name="swire.otherTnC1"
          data-test="onboarding-swire-other-tnc-1-checkbox"
          text={
            <div>
              <Trans
                i18nKey="web.onboarding.userProfile.swire.other.privacyPolicyAgreement"
                components={[agreementLinks[0]]}
              />
              <span
                style={{ color: colors.neutral.red7200, marginLeft: '0px' }}
              >
                *
              </span>
            </div>
          }
          labelStyles={labelStyles}
        />
      </div>
      <div style={{ marginBottom: '20px' }}>
        <HookFormCheckBox
          control={control}
          name="swire.otherTnC2"
          data-test="onboarding-swire-other-tnc-2-checkbox"
          text={
            <div>
              <Trans i18nKey="web.onboarding.userProfile.swire.other.tncAgreement2" />
              <span
                style={{ color: colors.neutral.red7200, marginLeft: '0px' }}
              >
                *
              </span>
            </div>
          }
          isRequired
          labelStyles={labelStyles}
        />
      </div>
      <div style={{ marginBottom: '20px' }}>
        <HookFormCheckBox
          control={control}
          name="swire.otherTnC3"
          data-test="onboarding-swire-other-tnc-3-checkbox"
          text={
            <div>
              <Trans i18nKey="web.onboarding.userProfile.swire.other.tncAgreement3" />
              <span
                style={{ color: colors.neutral.red7200, marginLeft: '0px' }}
              >
                *
              </span>
            </div>
          }
          isRequired
          labelStyles={labelStyles}
        />
      </div>
      <div style={{ marginBottom: '20px' }}>
        <HookFormCheckBox
          control={control}
          name="swire.otherTnC4"
          data-test="onboarding-swire-other-tnc-4-checkbox"
          text={
            <div>
              <Trans i18nKey="web.onboarding.userProfile.swire.other.tncAgreement4" />
              <span
                style={{ color: colors.neutral.red7200, marginLeft: '0px' }}
              >
                *
              </span>
            </div>
          }
          isRequired
          labelStyles={labelStyles}
        />
      </div>
      <div>
        <HookFormCheckBox
          control={control}
          name="marketingOptIn"
          data-test="onboarding-swire-other-tnc-5-checkbox"
          text={
            <Trans i18nKey="web.onboarding.userProfile.swire.other.tncAgreement5" />
          }
          labelStyles={labelStyles}
        />
      </div>
    </>
  );
}
